<script lang="ts">
    import src from './svg/arrow_back_ios_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
</script>

<TemplateIcon {src} {scale} alt="Add" on:click />
